import ProvinceForm from "./components/province-form";
import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { API_URL } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
const validationSchema = Yup.object({
  name: Yup.string().required("این فیلد الزامی است"),
});

const initialValues = {
  name: "",
  lat: "",
  long: "",
};

const NewProvince = ({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  refetch: () => void;
}) => {
  const handleClose = () => {
    setOpen(false);
    formik.resetForm();
  };
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "provinces", {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const notifications = useNotifications();

  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      let res;

      res = await insertAsync(values);

      if (res.status) {
        notifications.show("استان جدید با موفقیت ثبت شد!", {
          key: "new-province",
          severity: "success",
          autoHideDuration: 5000,
        });

        refetch();
        handleClose();
      } else {
        notifications.show("خطا در ذخیره سازی!", {
          key: "err-province",
          severity: "error",
          autoHideDuration: 5000,
        });
      }
      formik.resetForm();
    },
  });

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
        }}
      >
        <DialogTitle>استان جدید</DialogTitle>
        <DialogContent>
          <ProvinceForm formik={formik} />
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={isPending}
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={handleClose}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewProvince;
